export const TAVAHOT_TERMS_URL = "https://tavahot.com/policies/tnc.html";
export const TAVAHOT_PRIVACY_URL = "https://tavahot.com/policies/privacy-policy.html";


